import { FC } from 'react'
import cx from 'classnames'

import { AdsCardProps } from '../../AdsCard'

import * as SC from './styled'

export type BlockAdsRelatedProps = {
  className?: string
  title: string
  items: Array<AdsCardProps>
}

const BlockAdsRelated: FC<BlockAdsRelatedProps> = ({
  className,
  title,
  items,
}) => {
  return (
    <SC.BlockAdsRelated className={cx('BlockAdsRelated', className)}>
      <SC.Title>{title}</SC.Title>
      <SC.AdsRelatedList>
        {items.map((item, index) => (
          <SC.AdsRelatedListItem key={index}>
            <SC.Card {...item} />
          </SC.AdsRelatedListItem>
        ))}
      </SC.AdsRelatedList>
    </SC.BlockAdsRelated>
  )
}

export default BlockAdsRelated
